import React from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Header from './components/common/header/header.component';
import Sidebar from './components/common/sidebar/sidebar.component';

const AppWrapper = () => {
  return (
    <div className="page-wrapper">
      <Sidebar />
      <main className="page-body-wrapper">
        <Header />
        <div
          style={{
            padding: 16,
            width: '100%',
            height: 'calc(100vh - 64px)',
            overflow: 'scroll',
          }}
        >
          <Outlet />
        </div>
      </main>
      <ToastContainer />
    </div>
  );
};

export default AppWrapper;
